import { createRouter, createMemoryHistory } from 'vue-router'
import { authGuard } from './route-guards/auth-guard'

import Login from '@/pages/excel-addin/Login.vue'
import ProfileLite from '@/pages/accounts/ProfileLite.vue'
import ProductSelection from '@/pages/excel-addin/ProductSelection.vue'
import Freight from '@/pages/excel-addin/Freight.vue'
import Cargo from '@/pages/excel-addin/Cargo.vue'
import Access from '@/pages/excel-addin/Access.vue'
import Gas from '@/pages/excel-addin/Gas.vue'
import GasTransit from '@/pages/excel-addin/GasTransit.vue'
import Intraday from '@/pages/excel-addin/Intraday.vue'
import { ROUTE_NAMES } from './route-names'
import { RouteConstants } from '#/config/route'

const routes = [
  {
    path: '/',
    name: ROUTE_NAMES.LOGIN,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_NO_LOGIN,
      transitionLevel: 1,
    },
    component: Login,
  },
  {
    path: '/home',
    name: ROUTE_NAMES.HOME,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_LOGIN,
      transitionLevel: 2,
    },
    component: ProductSelection,
  },
  {
    path: '/product/access',
    name: ROUTE_NAMES.ACCESS,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_LOGIN,
      transitionLevel: 2,
    },
    component: Access,
  },
  {
    path: '/product/gas',
    name: ROUTE_NAMES.GAS,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_LOGIN,
      transitionLevel: 2,
    },
    component: Gas,
  },
  {
    path: '/product/gas-transit',
    name: ROUTE_NAMES.GAS_TRANSIT,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_LOGIN,
      transitionLevel: 2,
    },
    component: GasTransit,
  },
  {
    path: '/product/freight',
    name: ROUTE_NAMES.FREIGHT,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_LOGIN,
      transitionLevel: 2,
    },
    component: Freight,
  },
  {
    path: '/product/cargo',
    name: ROUTE_NAMES.CARGO,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_LOGIN,
      transitionLevel: 2,
    },
    component: Cargo,
  },
  {
    path: '/product/intraday',
    name: ROUTE_NAMES.INTRADAY,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_LOGIN,
      transitionLevel: 2,
    },
    component: Intraday,
  },
  {
    path: '/profile',
    name: ROUTE_NAMES.PROFILE,
    meta: {
      requireAuth: RouteConstants.ROUTE_ACCESS.REQUIRES_LOGIN,
      transitionLevel: 3,
    },
    component: ProfileLite,
  },
]

const router = createRouter({
  history: createMemoryHistory(),
  routes,
})

router.beforeEach(authGuard)

// Page Analytics
// router.afterEach((to: RouteLocation, from: RouteLocation) => {
//   analyticsPage(to.path, { query: to.query })
// })

export { router }
